export function workOrderStatesOdoo() {
  return [
    { code: 'draft', name: 'Draft' },
    { code: 'plan', name: 'Plan' },
    { code: 'ready', name: 'Ready' },
    { code: 'progress', name: 'In Progress' },
    { code: 'after_sale_transfer', name: 'After Sales Transfer' },
    { code: 'request', name: 'Request' },
    { code: 'rejected', name: 'Rejected' },
    { code: 'done', name: 'Done' },
    { code: 'canceled', name: 'Cancelled' },
  ]
}
